// extracted by mini-css-extract-plugin
export default {"infoBox":"InfoBox_infoBox__G6jtx","textWrapper":"InfoBox_textWrapper__C7wO+","big":"InfoBox_big__mttzf","content":"InfoBox_content__Q9i5o"};